import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-minus",
  "use": "n-icon-minus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-minus\">\n    <path d=\"M16.3 9.29999H10.7H9.3H3.7C3.3134 9.29999 3 9.61339 3 9.99999C3 10.3866 3.3134 10.7 3.7 10.7H9.3H10.7H16.3C16.6866 10.7 17 10.3866 17 9.99999C17 9.61339 16.6866 9.29999 16.3 9.29999Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol